module.exports = __webpack_public_path__ + "img/groupbuying_order_list.10377ced.svg";